// extracted by mini-css-extract-plugin
export default {"container":"RecordAction_container__9bG70"};